import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appImageResponsive]'
})
export class ImageResponsiveDirective {

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    const img = this.el.nativeElement
    const parent = img.parentElement
    const width = parent.offsetWidth

    // Hack because offsetHeight doesn't work:
    const height = (window.innerHeight * 0.4).toFixed() // parent.offsetHeight

    const src = img.getAttribute('data-src').replace(/block-\d+-\d+/, `block-${width}-${height}`)
    img.setAttribute('src', src)
  }
}
